import { init } from '@plausible-analytics/tracker';

// Plausible Cloud (cookieless). The site domain is baked in at build time like
// VITE_API_URL; when it's unset the tracker never initializes, so builds
// without it carry no analytics. The tracker ignores localhost by default,
// which keeps dev servers and the packaged desktop app (it serves the bundle
// from an ephemeral http://localhost:<port>) silent — only the deployed web
// app reports. Pageviews are auto-captured on History API navigations, which
// covers TanStack Router.
const domain = import.meta.env.VITE_PLAUSIBLE_DOMAIN as string | undefined;

if (domain) {
    init({ domain });
}
